import { DeployableType, ProjectileType, VisualEffect } from '@/types/enums';
import { WeaponCategory, WeaponConfig, WeaponType } from './type';

export const WEAPON_TYPES: Record<WeaponType | 'minibanana', WeaponConfig> = {
  [WeaponType.PISTOL]: {
    name: 'Pistolet',
    emoji: '🔫',
    fireRate: 500,
    damage: 10,
    bulletSpeed: 900,
    bulletCount: 1,
    spread: 0,
    price: 0,
    color: '#ffff00',
    range: 265,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 0.6,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.SMG]: {
    name: 'SMG',
    emoji: '💨',
    fireRate: 150,
    damage: 5,
    bulletSpeed: 900,
    bulletCount: 1,
    spread: 15,
    price: 50,
    color: '#ffa500',
    range: 215,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 0.4,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.SHOTGUN]: {
    name: 'Shotgun',
    emoji: '💥',
    fireRate: 800,
    damage: 8,
    bulletSpeed: 420,
    bulletCount: 5,
    spread: 30,
    price: 80,
    color: '#ff4444',
    range: 140,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 0.4,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.SNIPER]: {
    name: 'Snajperka',
    emoji: '🎯',
    fireRate: 1500,
    damage: 50,
    bulletSpeed: 900,
    bulletCount: 1,
    spread: 0,
    pierceCount: 2,
    price: 100,
    color: '#00ffff',
    range: 400,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 1.0,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.LASER]: {
    name: 'Laser',
    emoji: '⚡',
    fireRate: 100,
    damage: 3,
    bulletSpeed: 1200,
    bulletCount: 1,
    spread: 5,
    price: 120,
    color: '#ff00ff',
    range: 350,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 0.1,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.MINIGUN]: {
    name: 'Minigun',
    emoji: '🔥',
    fireRate: 50,
    damage: 2,
    bulletSpeed: 720,
    bulletCount: 1,
    spread: 20,
    price: 220,
    color: '#ff6600',
    range: 160,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 0.12,
    projectileType: ProjectileType.STANDARD,
  },
  [WeaponType.BAZOOKA]: {
    name: 'Bazooka',
    emoji: '🚀',
    fireRate: 2000,
    damage: 80,
    bulletSpeed: 300,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 80,
    explosionEffect: VisualEffect.STANDARD,
    price: 180,
    color: '#ff0000',
    bulletRadius: 10,
    range: 310,
    weaponCategory: WeaponCategory.ROCKET,
    projectileMass: 2.0,
    projectileType: ProjectileType.ROCKET,
  },
  [WeaponType.FLAMETHROWER]: {
    name: 'Miotacz Ognia',
    emoji: '🔥',
    fireRate: 80,
    damage: 2,
    bulletSpeed: 360,
    bulletCount: 3,
    spread: 40,
    price: 140,
    color: '#ff4400',
    bulletRadius: 6,
    shortRange: true,
    maxDistance: 120,
    range: 120,
    weaponCategory: WeaponCategory.SPECIAL,
    projectileMass: 0.01,
    projectileType: ProjectileType.FLAMETHROWER,
  },
  [WeaponType.MINES]: {
    name: 'Miny',
    emoji: '💣',
    fireRate: 4500,
    damage: 60,
    bulletSpeed: 0,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 70,
    explosionEffect: VisualEffect.STANDARD,
    price: 130,
    color: '#333333',
    bulletRadius: 12,
    range: 9999,
    weaponCategory: WeaponCategory.DEPLOYABLE,
    projectileMass: 1.0,
    deployableType: DeployableType.MINE,
  },
  [WeaponType.NUKE]: {
    name: 'Wyrzutnia Nuklearna',
    emoji: '☢️',
    fireRate: 8000,
    damage: 300,
    bulletSpeed: 180,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 200,
    explosionEffect: VisualEffect.NUKE,
    price: 500,
    color: '#00ff00',
    bulletRadius: 15,
    range: 9999,
    weaponCategory: WeaponCategory.ROCKET,
    projectileMass: 5.0,
    projectileType: ProjectileType.NUKE,
  },
  [WeaponType.SCYTHE]: {
    name: 'Kosa Kubusia',
    emoji: '🌙',
    fireRate: 1200,
    damage: 35,
    bulletSpeed: 360,
    bulletCount: 1,
    spread: 0,
    pierceCount: 3,
    price: 200,
    color: '#9932cc',
    bulletRadius: 20,
    range: 230,
    weaponCategory: WeaponCategory.MELEE,
    projectileMass: 2.5,
    projectileType: ProjectileType.SCYTHE,
    // TODO projectile section?
    rotationSpeed: 4, // ~0.6 rotations per second
  },
  [WeaponType.SWORD]: {
    name: 'Miecz Kamilka',
    emoji: '⚔️',
    fireRate: 700,
    damage: 10,
    bulletSpeed: 720,
    bulletCount: 3,
    spread: 60,
    price: 180,
    color: '#c0c0c0',
    bulletRadius: 8,
    shortRange: true,
    maxDistance: 100,
    range: 100,
    weaponCategory: WeaponCategory.MELEE,
    projectileMass: 0.4,
    projectileType: ProjectileType.SWORD,
  },
  [WeaponType.HOLY_GRENADE]: {
    name: 'Święty Granat',
    emoji: '✝️',
    fireRate: 3000,
    damage: 150,
    bulletSpeed: 360,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 120,
    explosionEffect: VisualEffect.HOLY,
    price: 250,
    color: '#ffd700',
    bulletRadius: 12,
    range: 275,
    weaponCategory: WeaponCategory.GRENADE,
    projectileMass: 1,
    explosiveRange: 275,
    projectileType: ProjectileType.HOLY_GRENADE,
    friction: 0.02,
  },
  [WeaponType.BANANA]: {
    name: 'Banan z Worms',
    emoji: '🍌',
    fireRate: 2500,
    damage: 40,
    bulletSpeed: 420,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 90,
    explosionEffect: VisualEffect.BANANA,
    price: 220,
    color: '#ffff00',
    bulletRadius: 10,
    range: 235,
    weaponCategory: WeaponCategory.GRENADE,
    projectileMass: 0.7,
    explosiveRange: 235,
    projectileType: ProjectileType.BANANA,
    rotationSpeed: 4, // ~0.6 rotations per second
    friction: 0.028,
  },
  [WeaponType.CROSSBOW]: {
    name: 'Kusza Przebijająca',
    emoji: '🏹',
    fireRate: 1000,
    damage: 60,
    bulletSpeed: 840,
    bulletCount: 1,
    spread: 0,
    pierceCount: 3,
    price: 280,
    color: '#8b4513',
    bulletRadius: 6,
    range: 320,
    weaponCategory: WeaponCategory.GUN,
    projectileMass: 1.0,
    projectileType: ProjectileType.CROSSBOW_BOLT,
  },

  // Internal type - mini banana spawned by main banana
  minibanana: {
    name: 'Mini Banan',
    emoji: '🍌',
    fireRate: 0,
    damage: 16,
    bulletSpeed: 600,
    bulletCount: 1,
    spread: 0,
    explosive: true,
    explosionRadius: 45,
    explosionEffect: VisualEffect.BANANA,
    price: 0,
    color: '#ffff00',
    bulletRadius: 6,
    range: 80,
    weaponCategory: WeaponCategory.GRENADE,
    projectileMass: 0.6,
    explosiveRange: 80,
    projectileType: ProjectileType.MINI_BANANA,
    rotationSpeed: 6, // ~0.8 rotations per second
    friction: 0.09,
  },
} as const;
